import React from 'react'
import { useQuery } from "@hooks/useQuery";
import { useNavigate } from "react-router-dom";
import { Tabs } from "antd";
import { AwardsList } from "./AwardList/AwardsList";
import AwardContent from './AwardContent';


const Awards = () => {
  const query = useQuery();
    const navigate = useNavigate();

    const awardTabItems = [
      {
        label: "Content",
        key: "awardsContent",
        children: (
          <div>
            <AwardContent />
          </div>
        ),
      },
      {
        label: "Awards List",
        key: "awardsList",
        children: (
          <div>
            <AwardsList />
          </div>
        ),
      },
    ];

  return (
    <Tabs
      activeKey={query?.get("thirdChildActiveTab") || ""}
      items={awardTabItems}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${query.get('subActiveTab')}&thirdChildActiveTab=${activeKey}`);
      }}
    ></Tabs>
  )
}

export default Awards